/* React hooks */
import {useEffect, useState} from "react";
/* Components*/
import useData from "../../hooks/useData";
import {createEstimateSection, getEstimateSectionList} from "../../api/admin/estimateReq";
import useAuth from "../../hooks/useAuth";
import FormButtons from "../../components/common/FormButtons";
import {getErrorListFromValidation, patternListChoices, removeErrorList, validateFormInput} from "../../helper/tools";
import Icon from "../../components/common/Icon";


export default function FormSectionCreate({ legend, setShowModalCreate }) {

    const { auth } = useAuth();
    const token = auth.token;
    const { estimateSectionList, setEstimateSectionList } = useData();

    const apiEstimateSectionList = async () => {
        const response = await getEstimateSectionList(token)
        setEstimateSectionList(response)
    }

    const [values, setValues] = useState({
        section: '',
        description: ''
    });

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        validateFormInput(e)
    };

    const handleSubmit = (e) => {
        e.preventDefault()

        const sectionExists = estimateSectionList?.some(
            section => section.section.toUpperCase() === values.section.toUpperCase()
        );

        if (sectionExists) {
            alert(`La section ${values.section} existe déjà. Veuillez choisir un autre numéro.`);
            return;
        }

        let body = {
            description: values?.description,
            section: values?.section.toUpperCase(),
        }
        return (createEstimateSection(body, token)
            .then((response) => {
                removeErrorList()
                if (!response?.response?.data?.error) {
                    setShowModalCreate(false)
                    apiEstimateSectionList()
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
        )
    }

    useEffect(() => {
        apiEstimateSectionList()
    }, [ token ]);

    const handleRemoveModal = () => {
        setShowModalCreate(false)
    };

    return (
        <form onSubmit={handleSubmit} method="post" noValidate>
            <fieldset>
                <Icon source="fa fa-list-ol" span={legend} />
                <div className="form-input">
                    <label htmlFor="section">Numéro de section (obligatoire)</label>
                    <input
                        type="text"
                        name="section"
                        pattern={patternListChoices?.section}
                        value={values?.section}
                        onChange={onChange}
                        placeholder="Ex: 8, 7A, 7B, 10A..."
                        required
                    />
                    <small>Format: nombre + lettre optionnelle (ex: 7, 7A, 7B, 10A)</small>
                </div>
                <div className="form-input">
                    <label htmlFor="description">Description (obligatoire)</label>
                    <textarea
                        name="description"
                        value={values?.description}
                        onChange={onChange}
                        required
                    />
                </div>
                <FormButtons handleRemoveModal={handleRemoveModal}/>
                <div className="errors"></div>
            </fieldset>
        </form>
    )
}